"use strict";
// Copyright © Veeam Software Group GmbH
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.booleanCellRenderer = void 0;
const trimmedTextRenderer_1 = require("@veeam/components/lib/Grid/cellRenderers/trimmedTextRenderer");
const helpers_1 = require("../../../helpers");
require("../../../core");
require("../types");
require("./types");
const booleanCellRenderer = (_a = {}) => {
    var { key, trueName = 'Yes', falseName = 'No', emptyValue } = _a, otherConfigProps = __rest(_a, ["key", "trueName", "falseName", "emptyValue"]);
    return (_a) => {
        var { cellData } = _a, otherProps = __rest(_a, ["cellData"]);
        const value = key ? otherProps.rowData[key] : cellData;
        const newValue = helpers_1.formatBoolean(!!value, trueName, falseName);
        return trimmedTextRenderer_1.trimmedTextRenderer(Object.assign(Object.assign(Object.assign({}, otherProps), otherConfigProps), { cellData: newValue }));
    };
};
exports.booleanCellRenderer = booleanCellRenderer;
//# sourceMappingURL=booleanCellRenderer.js.map